import { currentCsrfToken } from 'components/utils/apollo';

/* 🐛 ? */
// const endpoint =
//   process.env.NODE_ENV === 'test'
//     ? 'http://localhost:3000/graphql'
//     : '/graphql';
// 'test' env behaves differently between Jest and Rspec
export let graphqlEndpoint = '/graphql';
export function setGraphqlEndpoint(endpoint: string) {
  graphqlEndpoint = endpoint;
}

export const fetchData = <TData, TVariables>(
  query: string,
  variables?: TVariables,
  options?: RequestInit['headers']
): (() => Promise<TData>) => {
  return async () => {
    const res = await fetch(graphqlEndpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': currentCsrfToken,
        ...options,
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0] || {};
      throw new Error(message || 'Error…');
    }

    return json.data;
  };
};
